export interface IBodySite {
  bodySiteId: string,
  code: string,
  nameEnglish: string,
  nameArabic: string
}

export const bodySiteConfig = {
  entityName: 'CONFIGURATION.MASTER_DATA.BODY_SITE.TITLE',
  code: 'FORM_FIELD.CODE',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
};